import PropTypes from "prop-types";
import { BbotAccordion, BbotRichTextInput, Button, Collapse, SettingsCard } from "top-component-library";
import { GUEST_MESSAGE_GROUPS, QUILL_FORMATS, QUILL_MODULES } from "../constants";
import { EditorLabel, QuillWrapper, SaveRow, SectionHeading } from "../styles";

// One card per message category, each an accordion of its rich-text messages.
// Saving any message persists the whole set, matching the legacy behavior.
const GuestMessagesCard = ({ messages, onChange, onSave }) => {
  const messageValue = (id) => messages.find((message) => message.id === id)?.message ?? "";

  return (
    <>
      <SectionHeading>
        <p>
          <i>
            These can clarify your policies to guests. E.g. when drinks are in the cart, some restaurants show this
            message:
          </i>
          <br />
          <strong>Valid ID required if ordering alcohol. Refunds will not be given for lack of ID.</strong>
          <br />
          <i>For a clean checkout experience, use as few messages as possible, and keep them brief!</i>
          <br />
          Need Help?{" "}
          <a
            href="https://dd1psupport.zendesk.com/hc/en-us/articles/32479390662036-Presentation-to-Guests"
            target="_blank"
            rel="noopener noreferrer"
          >
            More Info.
          </a>
        </p>
      </SectionHeading>
      {GUEST_MESSAGE_GROUPS.map((group) => (
        <SettingsCard title={group.category} key={group.category}>
          <div>
            <BbotAccordion>
              {group.messages.map((message) => (
                <Collapse.Panel header={message.name} key={message.id}>
                  <EditorLabel>{message.name}.</EditorLabel>
                  <QuillWrapper>
                    <BbotRichTextInput
                      value={messageValue(message.id)}
                      onChange={(html) => onChange(message.id, html)}
                      modules={QUILL_MODULES}
                      formats={QUILL_FORMATS}
                    />
                  </QuillWrapper>
                  <SaveRow>
                    <Button type="primary" onClick={onSave}>
                      Save
                    </Button>
                  </SaveRow>
                </Collapse.Panel>
              ))}
            </BbotAccordion>
          </div>
        </SettingsCard>
      ))}
    </>
  );
};

GuestMessagesCard.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default GuestMessagesCard;
